import { storageKeys } from '../constants';
import safeStorage from './safeStorage';

const clearStorage = () => {
  Object.values(storageKeys).forEach((key) => {
    if (
      key !== storageKeys.IS_CONFIRM &&
      key !== storageKeys.IS_CONFIRM_TUTORIAL &&
      key !== storageKeys.CLIENT_ID &&
      key !== storageKeys.GIFT_SUGGESTIONS_DISPLAYED &&
      key !== storageKeys.LINE_SESSION_EXPIRES_AT_MS &&
      key !== storageKeys.BASIC_ID &&
      key !== storageKeys.LINE_SESSION_TOKEN
    ) {
      safeStorage.removeItem(key);
    }
  });
};

export default clearStorage;
